/**
 * #######################################################@
 *
 * Pages settings
 *
 * #######################################################@
 */
import "./style.css";

import DashboardLayout from "components/Advanced/LayoutContainers/DashboardLayout";
import lod_ from "lodash";
import {
	Checkbox,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	Icon,
	IconButton,
	List,
	ListItem,
	Menu,
	MenuItem
} from "@mui/material";
import { v4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import ChartsActions from "redux-react/actions/chartsActions";
import ProfileActions from "redux-react/actions/profileActions";
import SettingsActions from "redux-react/actions/settingsActions";
import FormActions from "redux-react/actions/formAction";
import { display, hide } from "redux-react/reducers/snackBarReducer";

import ConfirmDialog from "components/Custom/Dialogs/ConfirmDialog";
import DashboardNavbar from "components/Advanced/Navbars/DashboardNavbar";
import { useEffect, useMemo, useState } from "react";
import PagesDataTable from "components/Custom/Tables/PagesDataTable";
import MDButton from "components/Basics/MDButton";
import MDTypography from "components/Basics/MDTypography";
import i18n from "i18n";
import { t } from "i18next";
import AddPageDialog from "./AddPageDialog";
import DuplicatePageDialog from "./DuplicatePageDialog";
import MDBox from "components/Basics/MDBox";
import SidenavContainer from "pages/charts/Components/SidenavContainer";
import MDInput from "components/Basics/MDInput";
import colors from "assets/theme/base/colors";
import { useNavigate } from "react-router-dom";

export default function SettingsPages({ route }) {
	const { profile } = useSelector(state => state);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [paginedList, setPaginedList] = useState(null);
	const [filtersList, setFiltersList] = useState(null);

	const [addNewPage, setAddNewPage] = useState(false);
	const [tableLoading, setTableLoading] = useState(false);
	const [editPage, setEditPage] = useState({ open: false });
	// Confirm dialog
	const [confirmDialog, setConfirmDialog] = useState({
		open: false,
		title: "",
		content: "",
		handleConfirm: () => {}
	});

	const [duplicateDialog, setDuplicateDialog] = useState({
		open: false,
		page: {}
	});

	const [importFromCatalogDialog, setImportFromCatalogDialog] = useState({
		open: false
	});

	const [menuRef, setMenuRef] = useState(null);
	const [menuValues, setMenuValues] = useState({});
	/**
	 * Load pagined list
	 */
	function loadPaginedList() {
		const onSuccess = res => {
			setPaginedList(res.paginedList[0]);
			setTableLoading(false);
		};

		dispatch(ChartsActions.getPaginedList(profile.assistantID, route, onSuccess));
		// get filters
		dispatch(
			SettingsActions.getSettings(profile.assistantID, "filters", res => {
				setFiltersList(res.documents);
			})
		);
	}
	/**
	 * Handle page reorder
	 * @param {Number} from
	 * @param {Number} to
	 */
	function handleReorderPage(from, to) {
		const onSuccess = res => {
			dispatch(
				display({
					message: i18n.t("SETTINGS.PAGES.SUCCESS.edit"),
					type: "success"
				})
			);

			loadPaginedList();
			dispatch(ProfileActions.updateMenu(profile.assistantID));
		};
		dispatch(SettingsActions.reorderPage(profile.assistantID, { from, to }, onSuccess));
	}
	/**
	 * Handle delete page
	 */
	function actionDeleteHandle(page) {
		const handleConfirmDialog = () => {
			setConfirmDialog({
				open: false
			});
			const onSuccess = res => {
				dispatch(
					display({
						message: i18n.t("SETTINGS.PAGES.SUCCESS.delete"),
						type: "success"
					})
				);
				loadPaginedList();
				dispatch(ProfileActions.updateMenu(profile.assistantID));
			};
			dispatch(
				SettingsActions.deleteSetting(profile.assistantID, "page", { code: page.code }, onSuccess)
			);
		};

		setConfirmDialog({
			open: true,
			title: `${i18n.t("SETTINGS.delete")} : ${i18n.t(`SETTINGS.PAGES.${page.type}`)} ${
				page.name ? `"${page.name}"` : ""
			}`,
			content: `${i18n.t("SETTINGS.deleteConfirmation")} : ${i18n.t(
				`SETTINGS.PAGES.${page.type}`
			)} ${page.name ? `"${page.name}"` : ""} ?`,
			handleConfirm: handleConfirmDialog
		});
	}

	/**
	 * Duplicate
	 */
	const duplicateAction = (oldPage, newPageName) => {
		// 1- Duplicate page
		dispatch(
			FormActions.duplicateItem(
				{
					query: { route: oldPage.route, documentType: "page" },
					collection: "analytics",
					// updateFields: ["code"],
					setFields: {
						code: v4(),
						name: newPageName,
						route: `/${newPageName.toLowerCase().trim().replaceAll(" ", "-")}`
					}
				},
				res => {
					dispatch(
						display({
							message: i18n.t("FORMS.duplicateSuccess"),
							type: "success"
						})
					);
					loadPaginedList();
					dispatch(ProfileActions.updateMenu(profile.assistantID));
				},
				err => {
					dispatch(
						display({
							message: i18n.t("FORMS.duplicateError"),
							type: "error"
						})
					);
				}
			)
		);

		// 2- Duplicate charts on page
		dispatch(
			FormActions.duplicateItem(
				{
					query: { "display.pages": oldPage.route.replace("/", ""), documentType: "chart" },
					collection: "analytics",
					updateFields: ["code"],
					setFields: {
						"display.pages": [`${newPageName.toLowerCase().trim().replaceAll(" ", "-")}`]
					}
				},
				() => {},
				() => {}
			)
		);
	};
	/**
	 * When user create a page, set page's rank to the next rank
	 */
	function getNextRank(rows) {
		const maxRank = rows.reduce((acc, row) => {
			if (row.rank > acc) {
				return row.rank;
			}
			return acc;
		}, 0);
		return maxRank + 1;
	}

	/**
	 * Load pages list on mount
	 */
	useEffect(() => {
		loadPaginedList();
	}, []);

	return (
		<DashboardLayout>
			<DashboardNavbar
				filters={[
					<MDBox>
						<MDButton
							style={{ height: "100%", marginRight: "0.75rem" }}
							variant="contained"
							color="info"
							onClick={() => setAddNewPage(true)}
						>
							<Icon>add</Icon>&nbsp;{i18n.t("SETTINGS.PAGES.addPage")}
						</MDButton>
						<MDButton
							style={{ height: "100%", marginRight: "0.75rem" }}
							variant="contained"
							color="info"
							onClick={() => {
								setImportFromCatalogDialog({
									open: true
								});
							}}
						>
							<Icon>add</Icon>
							{t("SETTINGS.PAGES.importFromCatalog")}
						</MDButton>
					</MDBox>
				]}
			/>
			{/* Import from catalog dialog */}
			<ImportPagesDialog
				open={importFromCatalogDialog.open}
				onClose={() => setImportFromCatalogDialog({ open: false })}
				reloadPage={pageRoute => {
					loadPaginedList();
					dispatch(ProfileActions.updateMenu(profile.assistantID));

					dispatch(
						display({
							type: "info",
							message: i18n.t("SETTINGS.PAGES.SUCCESS.add"),
							validation: (
								<>
									<MDButton
										variant="contained"
										color="info"
										sx={{ ml: 1 }}
										onClick={() => {
											dispatch(hide());
											navigate(pageRoute);
										}}
									>
										{i18n.t("SETTINGS.see")}
									</MDButton>
									<MDButton
										sx={{ ml: 1 }}
										onClick={() => {
											dispatch(hide());
										}}
									>
										{i18n.t("SETTINGS.close")}
									</MDButton>
								</>
							)
						})
					);

					setImportFromCatalogDialog({ open: false });
				}}
			/>
			<Divider />
			{paginedList && (
				<div
					style={{
						position: "relative",
						width: "100%",
						height: "100%"
					}}
				>
					{tableLoading && (
						<div
							style={{
								width: "100%",
								height: "100%",
								backgroundColor: "rgba(0,0,0,0.2)",
								position: "absolute",
								top: 0,
								left: 0,
								zIndex: 100,
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								borderRadius: 10
							}}
						>
							<CircularProgress color="info" />
						</div>
					)}
					<PagesDataTable
						draggable
						table={paginedList.data}
						display={paginedList.request.attributesDisplay}
						dictionary={paginedList.dictionary}
						actions={[
							<IconButton
								handleclick={({ values }, e) => {
									setMenuValues(values);
									setMenuRef(e.currentTarget);
								}}
							>
								<Icon fontSize="medium">more_vert</Icon>
							</IconButton>
						]}
						dragHandler={({ from, to }) => {
							if (from === to) return;
							setTableLoading(true);
							handleReorderPage(from, to);
						}}
					/>

					<Menu
						open={Boolean(menuRef)}
						anchorEl={menuRef}
						onClose={() => {
							setMenuRef(null);
						}}
					>
						{/* Options */}
						<MenuItem disabled style={{ opacity: 1 }}>
							<MDTypography variant="caption">{t("SETTINGS.edition")}</MDTypography>
						</MenuItem>
						<MenuItem
							onClick={() => {
								setEditPage({ ...menuValues, open: true });
								setMenuRef(null);
							}}
						>
							<Icon fontSize="medium">edit</Icon>&nbsp;{i18n.t("SETTINGS.edit")}
						</MenuItem>

						<MenuItem
							onClick={() => {
								actionDeleteHandle(menuValues);
								setMenuRef(null);
							}}
							style={{
								color: "red"
							}}
						>
							<Icon fontSize="medium">delete</Icon>
							&nbsp;{i18n.t("SETTINGS.delete")}
						</MenuItem>

						<Divider />

						<MenuItem
							onClick={() => {
								setDuplicateDialog({
									open: true,
									page: menuValues
								});
								setMenuRef(null);
							}}
						>
							<Icon fontSize="medium">copy</Icon>&nbsp;{i18n.t("SETTINGS.duplicate")}
						</MenuItem>
					</Menu>
				</div>
			)}
			{paginedList && filtersList && (
				<AddPageDialog
					dictionary={paginedList.dictionary}
					open={addNewPage}
					handleCloseDialog={(reload = false) => {
						if (reload) {
							loadPaginedList();
						}
						setAddNewPage(false);
					}}
					rank={getNextRank(paginedList.data.rows)}
				/>
			)}
			{paginedList && filtersList && (
				<AddPageDialog
					dictionary={paginedList.dictionary}
					open={editPage.open}
					handleCloseDialog={(reload = false) => {
						if (reload) {
							loadPaginedList();
						}
						setEditPage({ open: false });
					}}
					rank={getNextRank(paginedList.data.rows)}
					page={editPage}
					filtersList={filtersList}
				/>
			)}
			<ConfirmDialog
				open={confirmDialog.open}
				title={confirmDialog.title}
				content={confirmDialog.content}
				handleClose={() => {
					setConfirmDialog({
						open: false
					});
				}}
				handleConfirm={confirmDialog.handleConfirm}
			/>
			{/* Duplicate page */}
			<DuplicatePageDialog
				dialog={duplicateDialog}
				setDialog={setDuplicateDialog}
				onSave={duplicateAction}
			/>
		</DashboardLayout>
	);
}

/**
 * Import pages from catalog dialog
 * @param {boolean} open - Open state
 * @param {function} onClose - Close function
 * @param {function} reloadPage - Function to reload the page after import
 * @returns {JSX.Element} - The ImportPagesDialog component
 */
const ImportPagesDialog = ({ open, onClose, reloadPage }) => {
	const dispatch = useDispatch();

	const [selectedRows, setSelectedRows] = useState([]);
	const [selectedTags, setSelectedTags] = useState([]);
	const [searchTextTags, setSearchTextTags] = useState("");
	const [searchText, setSearchText] = useState("");

	const [pages, setPages] = useState([]);
	const [tags, setTags] = useState([]);

	const getTagsCount = tag => {
		return pages.filter(page => (page.tags || []).includes(tag)).length;
	};

	const loadCharts = () => {
		dispatch(
			FormActions.getItemsFromCollection(
				"analytics",
				{
					account: "catalog",
					query: {
						documentType: "page",
						active: { $ne: false }
					},
					projection: {}
				},
				({ items: chatalogPages }) => {
					setPages(chatalogPages);
					// Set of all tags
					const possibleTags = [...new Set(chatalogPages.flatMap(page => page.tags || []))];
					possibleTags.sort();
					setTags(possibleTags);
				}
			)
		);
	};

	const importCharts = () => {
		dispatch(
			FormActions.importFromCatalog(
				{
					collection: "analytics",
					items: selectedRows,
					update: {
						active: true
					},
					actions: ["importAnalyticsPageFromCatalog"]
				},
				() => {
					const firstPageRoute = pages.find(page => page.code === selectedRows[0])?.route;
					reloadPage(firstPageRoute);
				},
				() => {
					dispatch(
						display({
							message: t("FORMS.importError"),
							type: "error"
						})
					);
				}
			)
		);
	};

	// Filters with tags and search text
	const filteredPages = useMemo(() => {
		return pages.filter(page => {
			const pageTags = page.tags || [];
			// Filter by tags
			if (
				selectedTags.length > 0 &&
				(lod_.isNil(pageTags) || !pageTags.some(tag => selectedTags.includes(tag)))
			) {
				return false;
			}

			const title = page.name || "";
			// Filter by search text
			if (searchText && !title.toLowerCase().includes(searchText.toLowerCase())) {
				return false;
			}

			return true;
		});
	}, [pages, selectedTags, searchText]);

	useEffect(() => {
		// Reset variables
		setSelectedRows([]);
		setSelectedTags([]);
		setSearchTextTags("");
		setSearchText("");
		setPages([]);
		setTags([]);
		// Load charts
		if (open) {
			loadCharts();
		}
	}, [open]);

	return (
		<Dialog
			fullWidth
			maxWidth="lg"
			open={open}
			PaperProps={{
				style: {
					height: "100%",
					width: "100%",
					maxWidth: "90%"
				}
			}}
		>
			<DialogTitle>{t("SETTINGS.PAGES.importFromCatalogTitle")}</DialogTitle>
			<DialogContent
				style={{
					display: "flex",
					overflowY: "auto"
				}}
			>
				<MDBox mt={1} display="flex" flex="1">
					<SidenavContainer>
						<List sx={{ pr: 1 }}>
							<ListItem sx={{ mb: 1 }}>
								<MDInput
									fullWidth
									placeholder={t("SETTINGS.PAGES.searchTags")}
									value={searchTextTags}
									onChange={e => setSearchTextTags(e.target.value)}
								/>
							</ListItem>
							{tags
								.filter(tag => tag.toLowerCase().includes(searchTextTags.toLowerCase()))
								.map(tag => (
									<ListItem
										key={tag}
										onClick={() => {
											if (selectedTags.includes(tag)) {
												setSelectedTags(prev => prev.filter(t => t !== tag));
											} else {
												setSelectedTags(prev => [...prev, tag]);
											}
										}}
										sx={{
											userSelect: "none",
											cursor: "pointer",
											transition: "background-color 0.1s",
											backgroundColor: selectedTags.includes(tag)
												? "rgba(0, 0, 0, 0.06)"
												: "inherit",
											"&:hover": {
												backgroundColor: "rgba(0, 0, 0, 0.06)"
											},
											borderRadius: "8px"
										}}
									>
										<Checkbox checked={selectedTags.includes(tag)} />
										<MDTypography variant="body2" fontWeight="regular" color="text">
											{tag} ({getTagsCount(tag)})
										</MDTypography>
									</ListItem>
								))}
						</List>
					</SidenavContainer>
					{/* Content */}
					<MDBox flex="1" display="flex" flexDirection="column">
						<MDBox>
							<MDInput
								fullWidth
								placeholder={t("SETTINGS.PAGES.searchPages")}
								value={searchText}
								onChange={e => setSearchText(e.target.value)}
							/>
						</MDBox>
						{/* Empty display */}
						{lod_.isEmpty(filteredPages) && (
							<MDBox
								flex="1"
								display="flex"
								flexDirection="column"
								alignItems="center"
								justifyContent="center"
							>
								<MDTypography variant="body2" color="textSecondary">
									{t("SETTINGS.PAGES.noPagesAvailable")}
								</MDTypography>
							</MDBox>
						)}
						<MDBox
							mt={2}
							display="grid"
							gridTemplateColumns="repeat(3, 1fr)"
							gap={2}
							sx={{
								overflowY: "auto"
							}}
						>
							{/* Real charts */}
							{filteredPages.map(page => {
								const isSelected = selectedRows.includes(page.code);

								return (
									<MDBox
										key={page.code}
										border="1px solid #ddd"
										borderRadius="8px"
										display="flex"
										flexDirection="column"
										alignItems="center"
										sx={{
											backgroundColor: isSelected ? colors.info.main : "white",
											transition: "all 0.2s",
											boxSizing: "border-box",
											"&:hover": {
												cursor: "pointer",
												border: "1px solid #aaa",
												boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
											}
										}}
										onClick={() => {
											if (isSelected) {
												setSelectedRows(prev => prev.filter(code => code !== page.code));
											} else {
												setSelectedRows(prev => [...prev, page.code]);
											}
										}}
									>
										{!lod_.isNil(page.image) && !lod_.isEmpty(page.image) ? (
											<MDBox
												sx={{
													height: "10rem",
													overflow: "hidden",
													borderRadius: "8px 8px 0 0"
												}}
											>
												<img
													src={page.image}
													alt={page.name}
													style={{ width: "100%", height: "100%", objectFit: "cover" }}
												/>
											</MDBox>
										) : (
											<MDBox
												sx={{
													width: "100%",
													height: "10rem",
													display: "flex",
													justifyContent: "center",
													alignItems: "center"
												}}
											>
												<MDBox
													bgColor="info"
													variant="gradient"
													coloredShadow="info"
													borderRadius="xl"
													display="flex"
													justifyContent="center"
													alignItems="center"
													width="3rem"
													height="3rem"
													color="white"
												>
													<Icon fontSize="small" color="inherit">
														insert_chart
													</Icon>
												</MDBox>
											</MDBox>
										)}
										<MDBox
											sx={{
												boxShadow: "inset 0px 5px 5px -5px rgba(0,0,0,0.2)",
												flex: 1,
												width: "100%",
												p: 1
											}}
										>
											<MDTypography variant="h6" color={isSelected ? "white" : "dark"}>
												{page.name}
											</MDTypography>
											<MDTypography variant="body2" color={isSelected ? "white" : "text"}>
												{page.description}
											</MDTypography>
										</MDBox>
									</MDBox>
								);
							})}
						</MDBox>
					</MDBox>
				</MDBox>
			</DialogContent>
			<DialogActions>
				<MDButton variant="outlined" color="info" onClick={onClose}>
					{t("SETTINGS.close")}
				</MDButton>
				<MDButton
					disabled={selectedRows.length === 0}
					variant="contained"
					color="info"
					onClick={importCharts}
				>
					{`${t("SETTINGS.import")} (${selectedRows.length})`}
				</MDButton>
			</DialogActions>
		</Dialog>
	);
};
